var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPiechart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2104 14.89C19.5742 16.3945 18.5792 17.7202 17.3123 18.7513C16.0454 19.7824 14.5452 20.4874 12.9428 20.8048C11.3405 21.1221 9.68483 21.0421 8.12055 20.5718C6.55627 20.1014 5.13103 19.2551 3.96942 18.1067C2.80782 16.9582 1.94522 15.5428 1.45704 13.9839C0.968859 12.4251 0.869965 10.7705 1.169 9.16463C1.46804 7.55878 2.1559 6.05063 3.17245 4.77203C4.189 3.49343 5.50329 2.48332 7.0004 1.83M21.0004 11C21.0004 9.68678 20.7417 8.38642 20.2392 7.17317C19.7367 5.95991 19.0001 4.85752 18.0715 3.92893C17.1429 3.00035 16.0405 2.26375 14.8272 1.7612C13.614 1.25866 12.3136 1 11.0004 1V11H21.0004Z",
    stroke: "#C9CED7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiechart);
export default __webpack_public_path__ + "static/media/piechart.64fa5f3326802a646e21deb382625988.svg";
export { ForwardRef as ReactComponent };